import { render, staticRenderFns } from "./SisterGroups.vue?vue&type=template&id=0739b804&scoped=true&"
import script from "./SisterGroups.vue?vue&type=script&lang=js&"
export * from "./SisterGroups.vue?vue&type=script&lang=js&"
import style0 from "./SisterGroups.vue?vue&type=style&index=0&id=0739b804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0739b804",
  null
  
)

export default component.exports